import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { colspan: "6" }
const _hoisted_2 = { class: "row mx-4" }
const _hoisted_3 = { class: "col m-0" }
const _hoisted_4 = { class: "list-group list-group-flush m-0" }
const _hoisted_5 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_6 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_7 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_8 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "list-group list-group-flush m-0" }
const _hoisted_11 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_12 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_13 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "list-group list-group-flush m-0" }
const _hoisted_16 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_17 = {
  class: "list-group-item",
  style: {"background-color":"transparent"}
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "incident-details mx-5 mt-3" }
const _hoisted_20 = { class: "description-text" }

import type { Incident } from '@/types/incidentsTypes';
  
  import { useIncidentStore } from '@/stores/useIncidentStore';
  import { Wrench, UserRound, Phone, CalendarClock } from 'lucide-vue-next';
  import { Calculator, Store, SquareCheck, KeyRound } from 'lucide-vue-next';
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'IncidentDetailComponent',
  props: {
    incident: {}
  },
  setup(__props: any) {

  const props = __props;
  const store = useIncidentStore();
  
  const toggleDetail = () => {
    store.toggleDetail(props.incident.id);
  };
  
  // Función para formatear la fecha y la hora
  const formatDateTime = (date: string | null | undefined, time: string | null | undefined): string => {
    if (!date) return "N/A";
  
    let formattedDate = new Date(date).toLocaleDateString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    
    let formattedTime = time ? time.slice(0, 5) : "";
  
    return time ? `${formattedDate} ${formattedTime}` : formattedDate;
  };
  
  /* defineEmits(['select']); */
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    onClick: toggleDetail,
    class: "incident-row table-info text-start"
  }, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_unref(KeyRound)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.id), 1)
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_unref(Store)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.expendeduria_name), 1)
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_unref(Calculator)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.maquina_name), 1)
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_unref(Wrench)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.operator_name), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_unref(SquareCheck)),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _createElementVNode("span", {
                class: _normalizeClass(["badge rounded-pill", _ctx.incident.is_resolved ? 'bg-success' : 'bg-danger'])
              }, _toDisplayString(_ctx.incident.is_resolved ? 'Resuelto' : 'Pendiente'), 3)
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_unref(CalendarClock)),
              _createTextVNode(" " + _toDisplayString(formatDateTime(_ctx.incident.incident_date, _ctx.incident.incident_time)), 1)
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_unref(CalendarClock)),
              _createTextVNode(" " + _toDisplayString(formatDateTime(_ctx.incident.resolution_date, _ctx.incident.resolution_time)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("ul", _hoisted_15, [
            _createElementVNode("li", _hoisted_16, [
              _createVNode(_unref(UserRound)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.client_name), 1)
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_unref(Phone)),
              _createTextVNode(" " + _toDisplayString(_ctx.incident.client_phone), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[1] || (_cache[1] = _createElementVNode("h5", null, "Descripcion:", -1)),
          _createElementVNode("pre", _hoisted_20, _toDisplayString(_ctx.incident.description), 1)
        ])
      ])
    ])
  ]))
}
}

})